import { SERVICE_STATUS } from "@home-health-notify/domain";
import {
  ProgressBreakdownItemContainer,
  StatusIndicator,
} from "./AssignedPatients.style";
import { patientServiceColor } from "hhn-commons";

const ActivePatientProgressBreakdownItem = ({
  label,
  status,
  count,
}: {
  label: string;
  status: SERVICE_STATUS;
  count: number;
}) => {
  return (
    <ProgressBreakdownItemContainer>
      <StatusIndicator
        data-testid="patient-status-indicator"
        color={patientServiceColor(status)}
      />
      <span>
        {label} <b>{count}</b>
      </span>
    </ProgressBreakdownItemContainer>
  );
};

export default ActivePatientProgressBreakdownItem;
